export const createNamespacer = (namespace: any) => (action: any) =>
  `${namespace}:${action}`;
export const getNamespace = (action: any) => {
  return action.type.split(":")[0];
};
export const getAction = (action: any) => {
  return action.type.split(":")[1];
};

export const createReducer = (
  initialState: any,
  handlers: any,
  namespaces: any,
) => {
  return (state: any = initialState, action: any) => {
    if (!action) {
      return state;
    }

    if (namespaces.includes(getNamespace(action))) {
      if (handlers[action.type]) {
        return handlers[action.type](state, action);
      }
    }

    return state;
  };
};
